// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"b00eacb4","721":"090c448b","951":"6348bd2c"}[chunkId] + ".chunk.js";
};